var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 367,
    height: 172,
    viewBox: "0 0 367 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.4004 154.64C80.4004 154.64 78.4372 149.271 75.9229 142.296H75.8123V141.987C73.4846 135.531 70.7079 127.77 68.5863 121.631V142.229H60.1259V112.995H65.7011C65.4841 112.3 65.3453 111.772 65.278 111.443C64.9201 109.71 65.3431 108.627 65.9635 107.716H41.3851V170.515H88.3271V169.319C83.0708 166.818 81.5718 157.795 80.4004 154.64ZM53.0669 142.296H44.6066V113.062H53.0669V142.296Z",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5841 147.284V144.547H60.1324V147.284H68.5841Z",
    fill: "#14B8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8122 147.348V144.61H76.6148L77.3676 147.348H75.8122Z",
    fill: "#14B8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0647 147.348V144.61H44.613V147.348H53.0647Z",
    fill: "#14B8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1976 162.621C65.8365 162.621 67.1652 161.295 67.1652 159.659C67.1652 158.023 65.8365 156.696 64.1976 156.696C62.5586 156.696 61.2299 158.023 61.2299 159.659C61.2299 161.295 62.5586 162.621 64.1976 162.621Z",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3027 161.43C81.9805 161.888 81.5352 162.245 81.0184 162.46C80.5015 162.675 79.9341 162.74 79.3819 162.647C78.8296 162.554 78.315 162.307 77.8975 161.934C77.4799 161.562 77.1766 161.079 77.0224 160.541C76.8683 160.004 76.8697 159.434 77.0264 158.897C77.1831 158.36 77.4888 157.879 77.9081 157.508C78.3274 157.138 78.8432 156.893 79.3959 156.803C79.9487 156.712 80.5157 156.78 81.0315 156.998",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6759 162.685C50.3149 162.685 51.6436 161.359 51.6436 159.723C51.6436 158.087 50.3149 156.761 48.6759 156.761C47.037 156.761 45.7083 158.087 45.7083 159.723C45.7083 161.359 47.037 162.685 48.6759 162.685Z",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5863 121.946V142.24H60.1346V113H65.4885",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0094 119.955H60.946",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0094 123.176H60.946",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0094 126.395H60.946",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0647 142.303V113.064H44.613V142.303H53.0647Z",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4942 133.415H45.2227",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4942 116.801H45.2227",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4942 136.636H45.2227",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4942 139.856H45.2227",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0156 83.6148C73.6234 82.5124 73.042 81.4865 72.2975 80.5831C69.6032 77.3067 69.5707 75.2257 68.0522 73.6558C66.5336 72.0858 64.1235 72.8026 66.2928 78.1275C66.6356 78.9677 66.9472 79.7306 67.2278 80.4164",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8458 80.0361C65.0541 80.0686 72.3908 80.6208 76.4214 86.6257",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9675 84.7435C67.6316 83.7604 79.2808 82.7339 81.5673 96.2205",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.161 100.262C69.5254 98.0552 68.7748 95.9634 67.957 94.6879C65.5577 90.946 60.1995 91.2231 60.1995 91.2231C60.1995 91.2231 46.5762 79.1636 44.6043 76.9851C42.6323 74.8067 43.3873 72.73 46.9124 75.151C48.7325 76.4005 52.4398 79.0488 55.5897 81.3247",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9673 90.6856C59.9673 90.6856 52.9712 75.1699 51.9235 72.2465C50.8757 69.3231 52.2922 67.7813 54.672 71.6597C55.7046 73.3444 57.3121 75.9906 58.7937 78.4528",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3055 89.4441C59.3055 89.4441 58.748 76.1351 58.7501 73.5561C58.7501 69.3052 61.3078 68.0969 61.9672 73.8267C62.4011 77.6531 62.8935 84.7061 62.8935 84.7061",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M260.762 83.8603C261.155 82.6678 261.766 81.5584 262.564 80.5882C265.261 77.3097 265.289 75.2265 266.814 73.6587C268.339 72.0909 270.741 72.8055 268.571 78.1304C268.205 79.0356 267.873 79.8513 267.573 80.5774",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M272.2 80.0332C270.272 80.0332 262.794 80.4317 258.608 86.3845",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M271.845 84.7325C267.148 83.7537 255.575 82.7835 253.295 96.2095",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M264.862 99.7067C265.463 97.708 266.163 95.8522 266.905 94.6828C269.304 90.9409 274.663 91.218 274.663 91.218C274.663 91.218 288.282 79.1607 290.258 76.9822C292.234 74.8037 291.475 72.7271 287.95 75.1481C286.082 76.43 282.229 79.1888 279.021 81.4972",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M274.895 90.6856C274.895 90.6856 281.891 75.1699 282.939 72.2465C283.986 69.3231 282.57 67.7813 280.192 71.6597C279.138 73.3747 277.489 76.0924 275.979 78.5892",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M275.977 78.6189C276.055 76.3517 276.114 74.3919 276.112 73.5561C276.112 69.3052 273.554 68.0969 272.895 73.8267C272.461 77.6531 271.97 84.7061 271.97 84.7061",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M275.556 89.4455C275.556 89.4455 275.813 83.3606 275.978 78.6182",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M137.965 67.0967C127.201 72.4649 123.804 80.8821 124.934 89.6501H124.83C124.83 89.6501 110.673 89.4617 102.742 112.981C100.419 107.524 98.0605 102.184 97.0474 100.512C94.7414 96.7182 86.8689 98.4225 84.8124 95.7871C82.7559 93.1517 82.027 92.3223 82.027 92.3223C82.027 92.3223 75.9095 99.6113 68.2692 98.7949C68.2692 98.7949 67.8353 100.107 68.126 103.42C68.4167 106.734 64.3796 107.113 65.2799 111.446C66.1801 115.779 80.3935 154.638 80.3935 154.638C81.7342 158.25 83.5043 169.552 90.8496 169.955C90.8696 170.007 90.9044 170.053 90.9498 170.087C90.9952 170.12 91.0493 170.14 91.1056 170.143C102.753 170.111 245.173 170.23 245.173 170.23C245.173 170.23 245.186 170.076 245.201 169.786C251.547 168.292 253.191 158.045 254.456 154.638C254.456 154.638 268.671 115.779 269.569 111.446C270.467 107.113 266.437 106.734 266.725 103.42C267.014 100.107 266.58 98.7949 266.58 98.7949C258.948 99.6005 252.829 92.3245 252.829 92.3245C252.829 92.3245 252.1 93.1474 250.045 95.7892C247.991 98.4311 244.091 95.4471 241.787 99.241C239.925 102.307 233.326 118.377 230.86 124.43C223.376 102.21 213.746 90.9191 198.036 88.078C197.005 81.8457 194.257 74.7711 187.3 69.6303",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M266.407 102.936C266.951 99.4711 266.669 98.1371 266.669 98.1371C259.697 99.6421 253.254 91.7295 253.254 91.7295C253.254 91.7295 252.523 92.6477 250.434 95.5667C249.839 96.4569 248.924 97.0848 247.878 97.3208C250.772 106.723 263.374 107.932 268.099 108.044C267.747 105.993 265.994 105.567 266.407 102.936Z",
    fill: "#0E3465"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0395 102.919C67.495 99.4537 68.1935 98.1371 68.1935 98.1371C75.1678 99.6421 81.6107 91.7295 81.6107 91.7295C81.6107 91.7295 82.6607 91.8464 84.7454 94.7612C85.5849 95.937 87.0275 96.9266 87.8974 97.167C85.0036 106.567 70.5103 107.843 65.7855 107.958C66.1413 105.913 68.4516 105.552 68.0395 102.919Z",
    fill: "#0E3465"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M125.448 89.2168C121.209 90.083 116.222 92.0103 112.337 96.3131C115.953 101.536 129.175 119.596 152.469 123.382C152.451 123.22 152.416 123.061 152.365 122.907C139.451 117.604 126.813 102.9 125.448 89.2168Z",
    fill: "#0E3465"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M197.177 86.8154C197.984 91.6271 197.763 95.9472 197.654 98.4982C197.296 106.931 194.196 112.754 191.814 116.95L191.359 119.967C201.197 117.652 209.375 101.993 210.692 93.0325C207.199 91.1334 205.733 88.5435 197.177 86.8154Z",
    fill: "#0E3465"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M152.2 117.317C152.2 117.317 161.55 133.42 162.52 143.591",
    stroke: "#0E3465",
    strokeWidth: 1.7382,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M190.088 116.917C190.088 116.917 186.14 132.762 187.209 142.924",
    stroke: "#0E3465",
    strokeWidth: 1.7382,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M102.49 112.128L112.63 135.818",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M231.207 123.773L224.298 137.249",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M132.826 153.099C132.826 153.099 131.959 170.73 122.726 170.319",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M184.471 124.081C189.437 109.413 187.508 91.0038 184.154 88.3359C183.48 87.8011 181.452 87.394 178.64 87.0843C177.464 86.9565 176.545 87.8097 176.545 87.8097L180.714 88.4594C178.855 106.242 170.904 111.847 170.904 111.847C157.947 96.9069 143.458 86.8916 143.458 86.8916L144.499 86.1748L143.762 86.1856L137.104 88.4745C137.104 88.4745 162.453 111.983 169.958 154.879C171.136 161.605 171.933 166.891 172.462 171.038L185.298 170.286C183.374 155.403 181.326 133.393 184.471 124.081Z",
    fill: "#0E3465"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M149.315 77.3711L148.99 83.0858L143.458 86.8927C143.458 86.8927 157.947 96.908 170.904 111.867C170.904 111.867 178.855 106.256 180.714 88.48L176.545 87.8303",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M142.119 56.8311C139.878 57.4677 135.268 59.5184 137.13 65.3544C138.742 70.4064 143.239 69.6182 146.074 68.5225",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M184.389 35.835C186.538 44.5229 187.163 54.025 187.135 61.3638L184.389 35.835Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M184.389 35.835C186.538 44.5229 187.163 54.025 187.135 61.3638",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M146.74 54.7197C148.319 55.9952 153.066 63.8689 154.437 67.639C154.437 67.639 163.454 63.2712 176.885 61.4847C176.885 61.4847 184.239 60.7722 187.265 61.3223C187.265 61.3223 188.204 75.1358 183.074 82.951C177.943 90.7662 165.138 90.2595 158.749 86.6757C152.36 83.0918 151.157 81.171 149.265 76.7556C147.373 72.3402 141.809 55.7029 141.809 55.7029L146.74 54.7197Z",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M143.252 58.1016C143.252 58.1016 138.512 52.244 136.219 45.8515C134.05 39.8423 136.163 33.0362 141.488 29.6104C145.944 26.7455 149.649 28.1574 149.649 28.1574C149.649 28.1574 143.666 20.0888 150.32 11.5763C151.474 10.0935 152.922 8.86374 154.573 7.96366C156.224 7.06357 158.043 6.51243 159.917 6.34455C169.121 5.55415 172.844 13.0943 172.844 13.0943C172.844 13.0943 180.603 -6.34947 201.96 2.15002C204.114 3.01621 206.744 5.78802 208.071 7.71097C216.124 19.3742 195.864 36.6461 184.586 39.1364C172.199 41.8692 164.628 40.6132 160.242 37.9713C163.45 39.4525 162.218 58.866 143.252 58.1016Z",
    fill: "#0E3465"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M175.763 52.8242L178.488 64.6347L174.984 65.4295",
    stroke: "#0E3465",
    strokeWidth: 1.7382,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M180.412 57.5655C181.08 57.491 181.526 56.5807 181.409 55.5324C181.291 54.4841 180.655 53.6947 179.987 53.7693C179.319 53.8439 178.872 54.7541 178.99 55.8024C179.107 56.8507 179.744 57.6401 180.412 57.5655Z",
    fill: "#0E3465"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M168.846 58.3341C169.514 58.2595 169.96 57.3493 169.843 56.301C169.726 55.2527 169.089 54.4633 168.421 54.5379C167.753 54.6124 167.307 55.5227 167.424 56.571C167.541 57.6193 168.178 58.4087 168.846 58.3341Z",
    fill: "#0E3465"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M164.344 53.3603C164.344 53.3603 169.292 53.0658 169.229 49.7656",
    stroke: "#0E3465",
    strokeWidth: 1.7382,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M178.586 45.0426C178.586 45.0426 181.84 43.7628 182.994 46.4437",
    stroke: "#0E3465",
    strokeWidth: 1.7382,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M174.689 70.6965C172.952 71.0138 171.184 71.1308 169.42 71.0451C168.336 70.9996 167.513 71.6688 167.834 72.3444C168.396 73.5311 169.739 74.943 172.928 74.5727C176.069 74.2002 176.696 72.7515 176.69 71.6363C176.685 70.965 175.672 70.5038 174.689 70.6965Z",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M203.65 143.457C203.192 143.457 202.744 143.593 202.363 143.847C201.982 144.101 201.685 144.462 201.51 144.885C201.334 145.307 201.289 145.772 201.378 146.221C201.467 146.67 201.688 147.082 202.012 147.405C202.336 147.729 202.749 147.949 203.198 148.038C203.648 148.127 204.114 148.081 204.537 147.906C204.96 147.731 205.322 147.435 205.577 147.055C205.831 146.674 205.967 146.227 205.967 145.77C205.967 145.157 205.722 144.569 205.288 144.135C204.854 143.701 204.265 143.458 203.65 143.457Z",
    fill: "#0E3465"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M196.19 159.726C195.575 159.726 194.986 159.969 194.552 160.403C194.117 160.837 193.873 161.425 193.873 162.038C193.873 162.652 194.117 163.24 194.552 163.674C194.986 164.107 195.575 164.351 196.19 164.351H196.201C196.815 164.35 197.404 164.105 197.837 163.67C198.271 163.235 198.514 162.646 198.512 162.033C198.511 161.42 198.265 160.832 197.83 160.399C197.394 159.966 196.804 159.724 196.19 159.726Z",
    fill: "#0E3465"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M255.746 138.491H192.836V154.206L181.291 154.399L181.367 170.114L248.041 169.798L247.965 154.206H255.753L255.746 138.491ZM198.761 164.577C198.428 164.917 198.031 165.188 197.593 165.374C197.154 165.56 196.683 165.657 196.207 165.659H196.19C195.23 165.662 194.309 165.283 193.629 164.607C192.948 163.932 192.565 163.014 192.563 162.056C192.56 161.098 192.939 160.178 193.616 159.499C194.293 158.82 195.213 158.438 196.173 158.435H196.19C196.901 158.438 197.597 158.65 198.188 159.044C198.78 159.439 199.242 159.999 199.516 160.655C199.79 161.31 199.865 162.032 199.731 162.729C199.596 163.427 199.259 164.069 198.761 164.577ZM203.65 149.377C202.935 149.377 202.235 149.165 201.64 148.768C201.045 148.371 200.581 147.807 200.307 147.147C200.033 146.487 199.962 145.761 200.101 145.06C200.241 144.36 200.585 143.716 201.092 143.211C201.598 142.706 202.242 142.362 202.944 142.222C203.646 142.083 204.374 142.155 205.035 142.428C205.696 142.701 206.261 143.164 206.659 143.758C207.056 144.352 207.269 145.051 207.269 145.765C207.269 146.723 206.888 147.643 206.209 148.321C205.531 148.999 204.61 149.38 203.65 149.381V149.377ZM213.74 165.945L213.698 157.5L216.44 157.487L216.48 165.932L213.74 165.945ZM217.135 141.707H219.877V150.152H217.135V141.707ZM217.707 165.926L217.666 157.48L246.952 157.342L246.993 165.787L217.707 165.926ZM250.393 150.144H221.107V141.698H250.393V150.144Z",
    fill: "#0E3465"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M240.025 164.859L239.995 158.59",
    stroke: "#14B8FF",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M236.799 164.874L236.769 158.604",
    stroke: "#14B8FF",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M233.574 164.889L233.543 158.62",
    stroke: "#14B8FF",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M230.005 149.087V142.818",
    stroke: "#14B8FF",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M246.65 149.087V142.818",
    stroke: "#14B8FF",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M226.779 149.087V142.818",
    stroke: "#14B8FF",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M223.554 149.087V142.818",
    stroke: "#14B8FF",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M321.766 115.57H243.854V170.426H321.766V115.57Z",
    fill: "#14B8FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M287.568 115.696V170.741V115.696Z",
    fill: "#14B8FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M287.568 115.696V170.741",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M277.08 121.647H312.333",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M298.409 141.355H321.058",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M273.555 159.741H317.711",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M279.724 136.429H256.899",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M243.941 127.807H257.779",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M243.854 153.145H270.91",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M243.737 127.893C237.919 130.179 243.913 134.006 243.913 134.006C243.913 134.006 245.412 129.675 253.078 127.91L243.737 127.893Z",
    fill: "#14B8FF",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M321.993 141.264C327.809 143.55 321.816 147.379 321.816 147.379C321.816 147.379 320.319 143.048 312.65 141.281L321.993 141.264Z",
    fill: "#14B8FF",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M264.303 153.183C264.303 153.183 250.803 155.725 251.137 163.653C251.137 163.653 240.316 159.69 243.978 153.183H264.303Z",
    fill: "#14B8FF",
    stroke: "#0E3465",
    strokeWidth: 1.30365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.064209 170.36H365.467",
    stroke: "#0E3465",
    strokeWidth: 1.7382,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTemplate);
export default __webpack_public_path__ + "static/media/no_template.a51f2c78922e09791baa2290d3357e43.svg";
export { ForwardRef as ReactComponent };